import axios from 'axios';
import { BaseApiService } from '@/services/backend/base';
import store from '@/store';

export class PersonalFl44UnknownVolumeAPIService extends BaseApiService {
    constructor() {
        super('personal/fl44_unknown_volume');
    }

    async declineSignContract(purchaseId, contractId, payload) {
        try {
            await axios.post(this.getUrl(`purchases/${purchaseId}/contracts/${contractId}/sign_decline`), payload);
            await store.dispatch('showSuccessToast', 'Отказ от подписания контракта принят');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async declineSendContract(purchaseId, payload) {
        try {
            await axios.post(this.getUrl(`purchases/${purchaseId}/decline_send_contract`), payload);
            await store.dispatch('showSuccessToast', 'Отказ от отправки контракта принят');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async storeSecondContract(purchaseId, payload) {
        try {
            await axios.post(this.getUrl(`purchases/${purchaseId}/store_second_contract`), payload);
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async getProposal(id) {
        try {
            const response = await axios.get(this.getUrl(`proposals/${id}`));
            return response.data.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getProposals(purchaseId) {
        try {
            const response = await axios.get(this.getUrl(`purchases/${purchaseId}/proposals`));
            return response.data.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async rejectProposal(proposalId, purchaseId, payload) {
        try {
            await axios.put(this.getUrl(`purchases/${purchaseId}/${proposalId}/decline_proposal`), payload);
            await store.dispatch('showSuccessToast', 'Предложение отклонено');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async storeProtocol(purchaseId, payload) {
        try {
            await axios.put(this.getUrl(`purchases/${purchaseId}/protocol`), payload);
            await store.dispatch('showSuccessToast', 'Итоговый протокол сформирован');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async publishPurchase(purchaseId, emails) {
        try {
            if (!purchaseId) throw Error('Id is not provided');
            await axios.post(this.getUrl(`purchases/${purchaseId}/publish`), { emails: emails });
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async sendApprovalRequest(purchase) {
        try {
            if (!purchase.id) throw Error('Id is not provided');
            await axios.post(this.getUrl(`purchases/${purchase.id}/notice_approval`));
            await store.dispatch('showSuccessToast', 'Извещение № ' + purchase.purchase_info.reg_number + ' отправлено на согласование в ГРБС / МО');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async unpublishPurchase(purchaseId, regNumber) {
        try {
            if (!purchaseId) throw Error('Id is not provided');
            await axios.post(this.getUrl(`purchases/${purchaseId}/unpublish`));
            await store.dispatch('showSuccessToast', 'Извещение № ' + regNumber + ' снято с публикации и доступно для редактирования');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getDurationChangeData(id) {
        try {
            const response = await axios.get(this.getUrl(`purchases/${id}/duration_change`));
            return response.data.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getDurationChangeXml(id) {
        try {
            const response = await axios.get(this.getUrl(`purchases/${id}/duration_change/get_xml`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeSignedDurationChange(purchaseId, xml, certificate, signedAttachments) {
        if (!certificate) {
            return false;
        }
        try {
            await axios.put(this.getUrl(`purchases/${purchaseId}/duration_change`), {
                xml: xml,
                certificate: certificate,
                signed_attachments: signedAttachments
            });
            await store.dispatch('showSuccessToast', 'Продолжительность закупочной сессии изменена');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async prolongPurchase(purchaseId) {
        try {
            if (!purchaseId) throw Error('Id is not provided');
            await axios.post(this.getUrl(`purchases/${purchaseId}/prolong`));
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async deletePurchase(purchaseId) {
        try {
            if (!purchaseId) throw Error('Id is not provided');
            await axios.delete(this.getUrl(`purchases/${purchaseId}`));
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async cancelPurchase(purchaseId, data) {
        try {
            if (!purchaseId) throw Error('Id is not provided');
            await axios.post(this.getUrl(`purchases/${purchaseId}/cancel`), data);
            await store.dispatch('showSuccessToast', 'Закупка успешно отменена');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async copyPurchase(purchaseId) {
        try {
            if (!purchaseId) throw Error('Id is not provided');
            const response = await axios.post(this.getUrl(`purchases/${purchaseId}/copy`));
            return response.data.id;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async updateComment(purchaseId, comment) {
        try {
            await axios.post(this.getUrl(`purchases/${purchaseId}/comment`), { purchase_comment: comment });
            await store.dispatch('showSuccessToast', 'Комментарий успешно обновлён');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeRating(formData, purchaseId) {
        try {
            await axios.post(this.getUrl(`purchases/${purchaseId}/store_rating`), { ...formData });
            await store.dispatch('showSuccessToast', 'Ваша оценка успешно принята');
            return true;
        } catch (error) {
            this.handleErrors(error);
            throw error;
        }
    }

    async changeStatus(purchaseId, payload) {
        try {
            await axios.post(this.getUrl(`purchases/${purchaseId}/change_status`), payload);
            await store.dispatch('showSuccessToast', 'Статус успешно изменён');
            return true;
        } catch (error) {
            this.handleErrors(error);
        }
    }

    async storeExecutionDocument(purchaseId, payload) {
        try {
            await axios.post(this.getUrl(`purchases/${purchaseId}/execution_documents`), payload);
            await store.dispatch('showSuccessToast', 'Документ успешно добавлен');
            return true;
        } catch (error) {
            this.handleErrors(error);
        }
    }

    async deleteExecutionDocument(purchaseId, executionDocumentId) {
        try {
            await axios.delete(this.getUrl(`purchases/${purchaseId}/execution_documents/${executionDocumentId}`));
            await store.dispatch('showSuccessToast', 'Документ успешно удалён');
            return true;
        } catch (error) {
            this.handleErrors(error);
        }
    }

    async getPurchaseReportsList(filters) {
        try {
            const response = await axios.get(this.getUrl('purchase_reports'), { params: filters });
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getPurchaseReport(reportId) {
        try {
            if (!reportId) throw Error('Id is not provided');
            const response = await axios.get(this.getUrl(`purchase_reports/${reportId}`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storePurchaseReport(reportId, data) {
        try {
            if (!reportId) throw Error('Id is not provided');
            await axios.post(this.getUrl(`purchase_reports/${reportId}`), data);
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getLimitsList(filters) {
        try {
            const response = await axios.get(this.getUrl('limits'), { params: filters });
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async refreshLimits() {
        try {
            await axios.post(this.getUrl('limits'));
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }
}
